import {API} from "@/Composables/api";

const getAudits = async (params = {}) => {
    return API.get(route("admin.audits.index"), params);
};

export {getAudits};
